<div class="row justify-content-center">
  <div class="col-xl-10 col-lg-12 col-md-9">
    <div class="card o-hidden border-0 shadow-lg my-5">
      <div class="card-body p-0">
        <!-- Nested Row within Card Body -->
        <div class="row">
          <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
          <div class="col-lg-6">
            <div class="p-5">
              <div class="text-center">
                <img width="300" src="assets/payretail.jpg" />
              </div>
              <form class="user">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control form-control-user"
                    id="exampleInputEmail"
                    aria-describedby="emailHelp"
                    placeholder="Enter Username"
                    [formControl]="form.controls.username"
                  />
                </div>
                <div class="form-group">
                  <input
                    type="password"
                    class="form-control form-control-user"
                    id="exampleInputPassword"
                    placeholder="Password"
                    [formControl]="form.controls.password"
                  />
                </div>
                <!-- <div style="display: flex; justify-content: space-between">
                  <div class="form-group">
                    <div class="custom-control custom-checkbox small">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customCheck"
                      />
                      <label class="custom-control-label" for="customCheck"
                        >Remember Me</label
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="custom-control custom-checkbox small">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="forgotCheck"
                      />
                      <label class="custom-control-label" for="forgotCheck"
                        >Forgot Password</label
                      >
                    </div>
                  </div>
                </div> -->
                <div style="display: flex; justify-content: center; margin-bottom: 16px;">
                  <a type="button" (click)="onForgotPassword()">Forgot Password</a>
                </div>
                <button
                  (click)="onSubmit()"
                  class="btn btn-primary btn-user btn-block"
                >
                  Login
                </button>
                <!-- <hr />
                <a href="index.html" class="btn btn-google btn-user btn-block">
                  <i class="fab fa-google fa-fw"></i> Login with Google
                </a>
                <a
                  href="index.html"
                  class="btn btn-facebook btn-user btn-block"
                >
                  <i class="fab fa-facebook-f fa-fw"></i> Login with Facebook
                </a> -->
              </form>
              <hr />
              <div class="text-center">
                <!-- <p>Don't have an account yet?</p>
                <a class="small" href="forgot-password.html"
                  ><span>
                    Create an account
                  </span>
                </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
